export const CREATE_RADAR = 'CREATE_RADAR'
export const CREATE_RADAR_SUCCESS = 'CREATE_RADAR_SUCCESS'

export const UPDATE_RADAR = 'UPDATE_RADAR'
export const UPDATE_RADAR_SUCCESS = 'UPDATE_RADAR_SUCCESS'

export const DELETE_SECTOR = 'DELETE_SECTOR'
export const DELETE_SECTOR_SUCCESS = 'DELETE_SECTOR_SUCCESS'

export const ADD_SECTOR = 'ADD_SECTOR'
export const ADD_SECTOR_SUCCESS = 'ADD_SECTOR_SUCCESS'

export const EDIT_SECTOR = 'EDIT_SECTOR'
export const EDIT_SECTOR_SUCCESS = 'EDIT_SECTOR_SUCCESS'

export const FETCH_RADAR = 'FETCH_RADAR'
export const FETCH_RADAR_SUCCESS = 'FETCH_RADAR_SUCCESS'

export const SET_DRAGGED_PHENOMENON = 'SET_DRAGGED_PHENOMENON'

export const UPDATE_PHENOMENON = 'UPDATE_PHENOMENON'
export const UPDATE_PHENOMENON_ASYNC = 'UPDATE_PHENOMENON_ASYNC'
export const UPDATE_PHENOMENON_ASYNC_SUCCESS = 'UPDATE_PHENOMENON_ASYNC_SUCCESS'

export const UPDATE_TIMERANGE = 'UPDATE_TIMERANGE'
export const UPDATE_TIMERANGE_SUCCESS = 'UPDATE_TIMERANGE_SUCCESS'

export const UPDATE_TIMERANGE_POSITION = 'UPDATE_TIMERANGE_POSITION'
export const UPDATE_TIMERANGE_POSITION_SUCCESS = 'UPDATE_TIMERANGE_POSITION_SUCCESS'

export const DELETING_RADAR = 'DELETING_RADAR'
export const DELETING_RADAR_SUCCESS = 'DELETING_RADAR_SUCCESS'

export const CREATE_PHENOMENA = 'CREATE_PHENOMENA'
export const CREATE_PHENOMENA_SUCCESS = 'CREATE_PHENOMENA_SUCCESS'

export const DELETE_PHENOMENA = 'DELETE_PHENOMENA'
export const DELETE_PHENOMENA_SUCCESS = 'DELETE_PHENOMENA_SUCCESS'

export const CREATE_PHENOMENA_POSITION = 'CREATE_PHENOMENA_POSITION'
export const CREATE_PHENOMENA_POSITION_SUCCESS = 'CREATE_PHENOMENA_POSITION_SUCCESS'

export const GET_ALL_PHENOMENA = 'GET_ALL_PHENOMENA'
export const GET_ALL_PHENOMENA_SUCCESS = 'GET_ALL_PHENOMENA_SUCCESS'

export const UPDATE_PHENOMENON_INGESTION = 'UPDATE_PHENOMENON_INGESTION'
export const UPDATE_PHENOMENON_INGESTION_SUCCESS = 'UPDATE_PHENOMENON_INGESTION_SUCCESS'

export const ARCHIVE_PHENOMENON = 'ARCHIVE_PHENOMENON'
export const ARCHIVE_PHENOMENON_SUCCESS = 'ARCHIVE_PHENOMENON_SUCCESS'

export const CLONE_RADAR = 'CLONE_RADAR'
export const CLONE_RADAR_SUCCESS = 'CLONE_RADAR_SUCCESS'

export const UPDATE_PHENOMENON_VERSION = 'UPDATE_PHENOMENON_VERSION'

export const REFETCH_DATA = 'REFETCH_DATA'
export const REFETCH_DATA_SUCCESS = 'REFETCH_DATA_SUCCESS'

export const UPDATE_RADAR_VERSION = 'UPDATE_RADAR_VERSION'

export const FETCH_SESSION = 'FETCH_SESSION'
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS'

export const LOADING = 'LOADING'
export const LOADING_SUCCESS = 'LOADING_SUCCESS'
export const LOADING_ERROR = 'LOADING_ERROR'

export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS'

export const CHANGE_GROUP = 'CHANGE_GROUP'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const CHANGE_TIME = 'CHANGE_TIME'
export const CHANGE_TYPE = 'CHANGE_TYPE'
export const CHANGE_TAG = 'CHANGE_TAG'
export const CHANGE_TYPES = 'CHANGE_TYPES'

export const FETCH_PHENOMENA = 'FETCH_PHENOMENA'
export const FETCH_PHENOMENA_SUCCESS = 'FETCH_PHENOMENA_SUCCESS'

export const GET_PHENOMENA_TYPES = 'GET_PHENOMENA_TYPES'
export const GET_PHENOMENA_TYPES_SUCCESS = 'GET_PHENOMENA_TYPES_SUCCESS'

export const GET_RADAR_SETS = 'GET_RADAR_SETS'
export const GET_RADAR_SETS_SUCCESS = 'GET_RADAR_SETS_SUCCESS'

export const GET_GROUPS = 'GET_GROUPS'
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS'

export const HANDLE_ADD_FORM_VISIBILITY = 'HANDLE_ADD_FORM_VISIBILITY'

export const CHANGE_RADAR_NAME = 'CHANGE_RADAR_NAME'
export const CHANGE_MAP_INTRO = 'CHANGE_MAP_INTRO'
export const CHANGE_RADAR_LANGUAGE = 'CHANGE_RADAR_LANGUAGE'
export const CHANGE_ADD_FORM_PAGE = 'CHANGE_ADD_FORM_PAGE'
export const CHANGE_PHENOMENA_SET = 'CHANGE_PHENOMENA_SET'
export const CHANGE_HIDE_USERS_FROM_TRIAL = 'CHANGE_HIDE_USERS_FROM_TRIAL'
export const CHANGE_RADAR_IMAGE = 'CHANGE_RADAR_IMAGE'
export const CHANGE_RADAR_TITLE_IMAGE = 'CHANGE_RADAR_TITLE_IMAGE'
export const CHANGE_VOTING_ON = 'CHANGE_VOTING_ON'
export const CHANGE_RATINGS_ON = 'CHANGE_RATINGS_ON'
export const CHANGE_RATINGS_SETTINGS = 'CHANGE_RATINGS_SETTINGS'
export const CHANGE_DISCUSSION_ON = 'CHANGE_DISCUSSION_ON'
export const CHANGE_COMMENTS_ON = 'CHANGE_COMMENTS_ON'
export const CHANGE_LIKING_ON = 'CHANGE_LIKING_ON'
export const CHANGE_VOTING_UP = 'CHANGE_VOTING_UP'
export const CHANGE_EXISTING_RADAR_PAGE = 'CHANGE_EXISTING_RADAR_PAGE'
export const CHANGE_DISPLAY_HALO_WHEN_RATING = 'CHANGE_DISPLAY_HALO_WHEN_RATING'
export const CHANGE_RADAR_SHARING = 'CHANGE_RADAR_SHARING'
export const CHANGE_RADAR_SHARING_EXPIRY = 'CHANGE_RADAR_SHARING_EXPIRY'
export const CHANGE_RADAR_GROUP = 'CHANGE_RADAR_GROUP'

export const HANDLE_EDIT_SECTOR_PAGE_VISIBILITY = 'HANDLE_EDIT_PAGE_VISIBILITY'
export const HANDLE_EDIT_TIMERANGES_PAGE_VISIBILITY = 'HANDLE_EDIT_TIMERANGES_PAGE_VISIBILITY'
export const HANDLE_ADD_PHENOMENA_VISIBILITY = 'HANDLE_ADD_PHENOMENA_VISIBILITY'
export const HANDLE_EDIT_PHENOMENA_VISIBILITY = 'HANDLE_EDIT_PHENOMENA_VISIBILITY'

export const GET_RSS_FEED = 'GET_RSS_FEED'
export const GET_RSS_FEED_SUCCESS = 'GET_RSS_FEED_SUCCESS'

export const HANDLE_SIGNAL_LIST_VISIBILITY = 'HANDLE_SIGNAL_LIST_VISIBILITY'
export const HANDLE_SIGNAL_CREATE_VISIBILITY = 'HANDLE_SIGNAL_ADD_VISIBILITY'

export const FETCH_SIGNALS = 'FETCH_SIGNALS'
export const FETCH_SIGNALS_SUCCESS = 'FETCH_SIGNALS_SUCCESS'
export const FETCH_MORE_SIGNALS_SUCCESS = 'FETCH_MORE_SIGNALS_SUCCESS'

export const CREATE_SIGNAL = 'CREATE_SIGNAL'
export const CREATE_SIGNAL_SUCCESS = 'CREATE_SIGNAL_SUCCESS'

export const ARCHIVE_SIGNAL='ARCHIVE_SIGNAL'
export const ARCHIVE_SIGNAL_SUCCESS='ARCHIVE_SIGNAL_SUCCESS'

export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'

export const USER_CHECKED = 'USER_CHECKED'
export const CLEAR_CHECKED_USERS = 'CLEAR_CHECKED_USERS'

export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'

export const CHANGE_ROLE = 'CHANGE_ROLE'
export const CHANGE_ROLE_SUCCESS = 'CHANGE_ROLE_SUCCESS'

export const SHOW_USER_RADARS = 'SHOW_USER_RADARS'

export const CHANGING_USER_RADARS = 'CHANGING_USER_RADARS'
export const CHANGING_USER_RADARS_SUCCESS = 'CHANGING_USER_RADARS_SUCCESS'

export const INVITE_USERS = 'INVITE_USERS'
export const INVITE_USERS_SUCCESS = 'INVITE_USERS_SUCCESS'

export const FETCH_LICENSE = 'FETCH_LICENSE'
export const FETCH_LICENSE_SUCCESS = 'FETCH_LICENSE_SUCCESS'

export const SET_GROUP_ID = 'SET_GROUP_ID'

export const FETCH_GROUP_RADARS = 'FETCH_GROUP_RADARS'
export const FETCH_GROUP_RADARS_SUCCESS = 'FETCH_GROUP_RADARS_SUCCESS'

export const CHANGE_GROUP_NAME = 'CHANGE_GROUP_NAME'
export const CHANGE_GROUP_NAME_SUCCESS = 'CHANGE_GROUP_NAME_SUCCESS'

export const FETCH_SHARES = 'FETCH_SHARES'
export const FETCH_SHARES_SUCCESS = 'FETCH_SHARES_SUCCESS'

export const REGENERATE_SHARE = 'REGENERATE_SHARE'
export const REGENERATE_SHARE_SUCCESS = 'REGENERATE_SHARE_SUCCESS'

export const CHANGE_USER_ROLE_FILTER = 'CHANGE_USER_ROLE_FILTER'

export const CHANGE_EMAIL_SEARCH = 'CHANGE_EMAIL_SEARCH'

export const TOGGLE_CONFIRM_DIALOG = 'TOGGLE_CONFIRM_DIALOG'

export const TOGGLE_EDIT_MENU_VISIBILITY = 'CHANGE_EDIT_MENU_VISIBILITY'

export const UPDATE_TIMELINES = 'UPDATE_TIMELINES'

export const REMOVE_TIMELINE = 'REMOVE_TIMELINE'
export const REMOVE_TIMELINE_SUCCESS = 'REMOVE_TIMELINE_SUCCESS'

export const ADD_TIMERANGE = 'ADD_TIMERANGE'
export const ADD_TIMERANGE_SUCCESS = 'ADD_TIMERANGE_SUCCESS'

export const TOGGLE_LABEL_MODE = 'TOGGLE_LABEL_MODE'

export const TOGGLE_FILTERS = 'TOGGLE_FILTERS'
export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER'
export const SET_ACTIVE_TAG_FILTER = 'SET_ACTIVE_TAG_FILTER'
export const RESET_FILTERS = 'RESET_FILTERS'
export const RESET_TYPE_FILTERS = 'RESET_TYPE_FILTERS'
export const RESET_TAGS = 'RESET_TAGS'
export const SET_PHENOM_TO_TAG = 'SET_PHENOM_TO_TAG'

export const ADD_PHENOMENA_TAG = 'ADD_PHENOMENA_TAG'
export const ADD_PHENOMENA_TAG_SUCCESS = 'ADD_PHENOMENA_TAG_SUCCESS'
export const REMOVE_PHENOMENA_TAG = 'REMOVE_PHENOMENA_TAG'
export const REMOVE_PHENOMENA_TAG_SUCCESS = 'REMOVE_PHENOMENA_TAG_SUCCESS'

export const GENERATE_POWERPOINT = 'GENERATE_POWERPOINT'
export const GENERATE_POWERPOINT_SUCCESS = 'GENERATE_POWERPOINT_SUCCESS'
